import type { DatabaseFile } from '../types';
import type { GitHubService } from './GitHubService';
import { audioRepoPath } from '../utils/itemAudio';

export async function syncItemAudioForFile(github: GitHubService, file: DatabaseFile): Promise<void> {
  for (const path of file.orphanedAudioPaths) {
    const sha = await github.getBlobSha(path);
    if (sha) await github.deleteFile(path, sha, `App: remove audio ${path.split('/').pop()}`);
  }
  file.orphanedAudioPaths = [];

  for (const section of file.sections) {
    for (const item of section.items) {
      for (const filename of item.audioToDelete) {
        const path = audioRepoPath(file.path, filename);
        const sha = await github.getBlobSha(path);
        if (sha) await github.deleteFile(path, sha, `App: remove audio ${filename}`);
        item.audio = item.audio.filter(f => f !== filename);
      }
      item.audioToDelete = [];

      for (const pending of item.pendingAudio) {
        const path = audioRepoPath(file.path, pending.filename);
        const buf = await pending.file.arrayBuffer();
        await github.writeBinary(path, buf, '', `App: add audio ${pending.filename}`);
        if (!item.audio.includes(pending.filename)) item.audio.push(pending.filename);
      }
      item.pendingAudio = [];
    }
  }
}

export function queueOrphanedAudioForItem(file: DatabaseFile, item: { audio: string[] }): void {
  for (const filename of item.audio) {
    file.orphanedAudioPaths.push(audioRepoPath(file.path, filename));
  }
}
